import React from "react";
import "../styles/wc.css";

export default function ReasonBanner({ verdict, statement }) {
    const cls =
        verdict === "green" ? "wc-banner wc-banner--green" :
            verdict === "red" ? "wc-banner wc-banner--red" :
                "wc-banner wc-banner--amber";
    const icon = verdict === "green" ? "✅" : verdict === "red" ? "⛔" : "⚠️";

    // Extract verdict title based on type
    const getTitle = () => {
        if (verdict === "green") return "📈 Positive Working Capital Trend (3-Year View)";
        if (verdict === "red") return "📉 Concerning Working Capital Trend (3-Year View)";
        return "⚠️ Mixed Working Capital Signals (3-Year View)";
    };

    return (
        <div className={cls} style={{ flexDirection: 'column', alignItems: 'flex-start' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                <div className="wc-banner__icon" aria-hidden>{icon}</div>
                <strong style={{ fontSize: '15px' }}>{getTitle()}</strong>
            </div>
            <p className="wc-banner__text" style={{ marginLeft: '28px', lineHeight: '1.5' }}>
                {statement}
            </p>
        </div>
    );
}
